import { Classifier } from '@jobilla/classifier'
import { useTranslation } from 'react-i18next'

export function WorkHistoryHints({ contents }: { contents: string }) {
	const { t, i18n } = useTranslation('common')

	return (
		<Classifier model="work-history" language={i18n.language.split('-')[0]} contents={contents}>
			{labels => (
				<ul
					aria-label={t('profile.work_history.hints.label')}
					className="grid grid-cols-[repeat(auto-fit,minmax(9rem,1fr))] gap-x-3 gap-y-1 border-t border-grey-200 bg-grey-50 px-3.5 py-2 text-xs text-grey-500"
				>
					{labels.map(label => {
						const isDetected = label.detected

						return (
							<li
								key={label.name}
								className={`flex items-center transition-colors duration-300 ${
									isDetected ? 'text-green-700' : ''
								}`}
							>
								<HintMark key={String(isDetected)} isDetected={isDetected} />
								{label.title}
								<span className="sr-only">
									: {isDetected
										? t('profile.work_history.hints.included')
										: t('profile.work_history.hints.missing')}
								</span>
							</li>
						)
					})}
				</ul>
			)}
		</Classifier>
	)
}

function HintMark({ isDetected }: { isDetected: boolean }) {
	if (!isDetected) {
		return (
			<svg aria-hidden={true} viewBox="0 0 16 16" className="mr-1 size-3.5 shrink-0">
				<circle
					cx="8"
					cy="8"
					r="6.5"
					fill="none"
					strokeWidth={1.3}
					strokeDasharray="2.2 2.2"
					className="stroke-grey-400"
				/>
			</svg>
		)
	}

	return (
		<svg
			aria-hidden={true}
			viewBox="0 0 16 16"
			className="mr-1 size-3.5 shrink-0 animate-pop-in motion-reduce:animate-none"
		>
			<circle cx="8" cy="8" r="7" strokeWidth={1.5} className="fill-green-50 stroke-green-600" />
			<path
				d="M5 8.2l2 2 4-4.2"
				fill="none"
				strokeWidth={1.8}
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeDasharray={10}
				strokeDashoffset={10}
				className="animate-draw-check stroke-green-600 motion-reduce:animate-none motion-reduce:[stroke-dashoffset:0]"
			/>
		</svg>
	)
}
